<template>
  <div>
    <TopBar
      :title="topBarTitle"
      @go-back="goBack"
      :show-back-button="true"
      :show-toggle="true"
      :prevent-go-back="preventGoBack"
      class="mb-8"
    />

    <ScanProduct v-if="!readProduct" />

    <div v-else>
      <MoProductCard :card-data="moProductCardData" />
      <TextInput
        type="text"
        ref="serialNumberInput"
        class="mt-5 w-full"
        label="Número de série"
        v-model="serialNumber"
        theme="secondary"
        :upper-case="true"
        :align="'center'"
        :is-virtual-keyboard-enabled="true"
        :disabled="true"
      />

      <TextInput
        type="text"
        ref="tagCodeInput"
        class="mt-5 w-full"
        label="Código da TAG"
        :disabled="true"
        v-model="currentTag"
      />

      <VButton
        class="mt-52"
        :disabled="false"
        type="outline"
        title="Fechar"
        :callback="goBackByClose"
      />
    </div>

    <!-- <ProductDetails v-else /> -->
  </div>
</template>

<script setup lang="ts">
import VButton from '@/components/Button/VButton.vue'
import MoProductCard from '@/components/MoProductCard/MoProductCard.vue'
import { useFetchProduct } from '@/components/ScanProduct/query'
import ScanProduct from '@/components/ScanProduct/ScanProduct.vue'
import TextInput from '@/components/TextInput/TextInput.vue'
import TopBar from '@/components/TopBar/TopBar.vue'
import { useEventBus } from '@/plugins/eventBus/eventBus'
import { useAppStore } from '@/stores/app.store'
import { computed, onMounted, ref, watch } from 'vue'
import { useRouter } from 'vue-router'

const eventBus = useEventBus()
const router = useRouter()
const appStore = useAppStore()

const readProduct = computed(() => appStore.currentReadProduct)

const serialNumber = computed(() => appStore.currentReadProduct?.serialNumber || '')
const currentTag = computed(() => appStore.currentTagReadProduct || '')

const { data, refetch } = useFetchProduct(currentTag)

const moProductCardData = computed(() =>
  appStore.currentReadProduct
    ? {
        imageUrl: '',
        productUnitCode: '',
        primaryColorHex: appStore.currentReadProduct.primaryColorHex,
        secondaryColorHex: appStore.currentReadProduct.secondaryColorHex,
        description: appStore.currentReadProduct.description,
        size: appStore.currentReadProduct.size,
        year: parseInt(appStore.currentReadProduct.year),
        checked: 0,
        problem: 0,
        total: 0,
        loadedAt: appStore.currentReadProduct?.loadedAt
      }
    : null
)

let showCam = ref(false)

const isScanningTag = ref(false)

const topBarTitle = computed(() => (readProduct.value ? 'Produto' : null))

appStore.actions.topBar.setTopBarTitle(topBarTitle.value)

const preventGoBack = computed(() => showCam.value || isScanningTag.value)

async function handleClickLoadProduct() {
  isScanningTag.value = true
}

async function goBack() {
  if (showCam.value) {
    showCam.value = false
    return
  }

  if (isScanningTag.value) {
    isScanningTag.value = false
  }
}

async function goBackByClose() {
  router.push({ name: 'home-read-product' })
}

async function refetchProduct() {
  if (currentTag.value) {
    await refetch()

    if (data.value) {
      appStore.actions.setCurrentReadProduct(data.value)
    }
  }
}

watch(data, async () => {
  if (data.value) {
    appStore.actions.setCurrentReadProduct(data.value)
  }
})

watch(isScanningTag, async () => {
  if (!isScanningTag.value) {
    eventBus.on('moDetails:loadProduct', handleClickLoadProduct)
  }
})

onMounted(async () => {
  await refetchProduct()
})
</script>
